/**
 * 文档目录（TOC）— 从 heading blocks 提取，侧边抽屉展示
 *
 * 点击目录项滚动到对应 block
 */

import { useMemo } from 'react';
import { List } from 'lucide-react';
import { Drawer, IconButton } from '@hump/ui';
import { useReaderStore } from '../../stores/reader';

export function TableOfContents() {
  const { blocks, tocOpen, setTocOpen } = useReaderStore();

  const headings = useMemo(
    () => blocks.filter((b) => b.type === 'heading'),
    [blocks]
  );

  function scrollToBlock(blockId: string) {
    const el = document.querySelector(`[data-block-id="${blockId}"]`);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setTocOpen(false);
    }
  }

  if (headings.length < 2) return null;

  return (
    <>
      <IconButton
        size="sm"
        onClick={() => setTocOpen(true)}
        title="目录"
        aria-label="目录"
      >
        <List className="w-4 h-4" />
      </IconButton>

      <Drawer open={tocOpen} onClose={() => setTocOpen(false)} side="left" title="目录">
        <nav className="space-y-1">
          {headings.map((h) => (
            <button
              key={h.id}
              onClick={() => scrollToBlock(h.id)}
              className={`block w-full text-left rounded-md px-2 py-1.5 text-sm transition-colors hover:bg-warm-white dark:hover:bg-border-warm-dark ${
                h.level === 1
                  ? 'font-medium text-charcoal dark:text-charcoal-light'
                  : h.level === 2
                    ? 'pl-4 text-charcoal/70 dark:text-charcoal-light/70'
                    : 'pl-6 text-charcoal/50 dark:text-charcoal-light/50'
              }`}
            >
              {h.original}
            </button>
          ))}
        </nav>
      </Drawer>
    </>
  );
}
